<template>
  <div class="home">
    <HelloWorld msg="Congrats, your Hello World app is working 🚀"/>

    <h1>Some data from mock service :</h1>
    <div v-loading="loading">
      <span
        style="display: block;"
        v-for="(fakeCustomer, key) in fakeCustomers"
        :key="key">
        {{ fakeCustomer.displayNameAndEmail }}
      </span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import services from 'services';
import HelloWorld from '@/components/HelloWorld.vue';

export default {
  components: {
    HelloWorld,
  },
  async mounted() {
    this.loading = true;
    /* Here we use the service directly. You might prefer to use the store instead */
    this.fakeCustomers = await services.fakeCustomerService.fetchAll();
    console.log(this.fakeCustomers);
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      fakeCustomers: [],
    };
  },
};
</script>
